/*const swiper = new Swiper('.swiper-testimonials', {
    loop: true,
    speed: 2600,
    grabCursor: true,
    allowTouchMove: true,
    autoplay: {
        delay: 1,
        disableOnInteraction: true
    },
    breakpoints: {
        1: {
            slidesPerView: 1,
            spaceBetween: 12,
        },
        320: {
            slidesPerView: 1.5,
            spaceBetween: 12,
        },
        500: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        700: {
            slidesPerView: 3.05,
            spaceBetween: 20,

        },
        1600: {
            slidesPerView: 4.05,
            spaceBetween: 20,
        },
        1920: {
            slidesPerView: 6,
            spaceBetween: 20,
        }
    }
});*/

/*  const swiperContainer = document.querySelector('.swiper-testimonials');
  swiperContainer.addEventListener('mouseenter', function() {
    swiper.autoplay.stop();
    swiper.speed = 0;
  });
  swiperContainer.addEventListener('mouseleave', function() {
      swiper.autoplay.start();
      swiper.slideTo(swiper.activeIndex, swiper.savedSpeed);
  });*/

var owl = $('.testimonials-carousel');
owl.owlCarousel({
    items:6,
    center:true,
    autoplay:true,
    autoPlayTimeout:100,
    autoplaySpeed:2600,
    autoHeight:true,
    autoplayHoverPause:false,
    loop:true,
    responsive : {
        // breakpoint from 0 up
        0 : {
            items: 1,
            margin: 12,
        },
        // breakpoint from 480 up
        320 : {
            items: 1.5,
            margin: 12,
        },
        // breakpoint from 768 up
        500 : {
            items: 2,
            margin: 20,
        },
        700 : {
            items: 3.05,
            margin: 20,
        },
        1600 : {
            items: 4.05,
            margin: 20,
        },
        1920 : {
            items: 6,
            margin: 20,
        }
    }
});